// connectorPathMath — små pure helpers som används av ConnectorPath.tsx
// för att placera "+Label"-anchorn i GEOMETRISK mittpunkt av polyline,
// inte vid array-index-mittpunkt (som snappar till waypoint).

export interface Point { x: number; y: number }

/**
 * Summa av segment-längder i ordningen de ligger i arrayen.
 */
export function totalArcLength(points: Point[]): number {
  if (points.length < 2) return 0;
  let total = 0;
  for (let i = 0; i < points.length - 1; i++) {
    const dx = points[i + 1].x - points[i].x;
    const dy = points[i + 1].y - points[i].y;
    total += Math.hypot(dx, dy);
  }
  return total;
}

/**
 * Returnera punkten vid fraktion `t` (0..1) längs polyline:en genom
 * linjär interpolation. t=0 → första punkten; t=1 → sista. t=0.5 är
 * polylinens geometriska mittpunkt (oberoende av waypoint-index).
 *
 * Om bara en punkt finns returneras den oförändrad.
 */
export function pointAtArcLength(points: Point[], t: number): Point {
  if (points.length === 0) return { x: 0, y: 0 };
  if (points.length === 1) return { ...points[0] };
  const clampedT = Math.max(0, Math.min(1, t));
  const targetLen = clampedT * totalArcLength(points);
  let accumulated = 0;
  for (let i = 0; i < points.length - 1; i++) {
    const a = points[i];
    const b = points[i + 1];
    const segLen = Math.hypot(b.x - a.x, b.y - a.y);
    if (accumulated + segLen >= targetLen || i === points.length - 2) {
      const segT = segLen > 0 ? (targetLen - accumulated) / segLen : 0;
      return {
        x: a.x + segT * (b.x - a.x),
        y: a.y + segT * (b.y - a.y),
      };
    }
    accumulated += segLen;
  }
  // Skulle aldrig nås — sista segment fångar upp det, men TS vill ha return.
  return { ...points[points.length - 1] };
}
